// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__xd5-0","footer__link":"Footer_footer__link__ghmSa"};